import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=0747b7a5&scoped=true&"
import script from "./AdminList.vue?vue&type=script&lang=js&"
export * from "./AdminList.vue?vue&type=script&lang=js&"
import style0 from "./AdminList.vue?vue&type=style&index=0&id=0747b7a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747b7a5",
  null
  
)

export default component.exports